import React from "react";
import AjudaModal from "./AjudaModal";

const LEAD = "Cada pestanya és una peça de la vida laboral d'aquest empleat: horari, absències, baixes, fitxatges, calendari i resum.";

function AjudaGestioEmpleat({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.horari;
  return (
    <AjudaModal id="gestio-empleat-ajuda-title" titol={contingut.titol} lead={LEAD} onTancar={onTancar}>
      {contingut.cos}
    </AjudaModal>
  );
}

const CONTINGUT = {
  horari: {
    titol: "Com funciona l'Horari de l'empleat",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Per a què serveix</h4>
          <p>
            És l'horari d'aquest empleat, no el de l'empresa. Si l'agafa de l'empresa, se'n fa una còpia: canviar-lo
            aquí no modifica l'Horari d'empresa ni el d'altres empleats.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Què pots fer</h4>
          <ul>
            <li>
              <strong>Modificar horari</strong> (a dalt) obre l'edició. Sense això només es consulta.
            </li>
            <li>
              Sense horari: <strong>Agafar horari d'empresa</strong> o <strong>Crear horari nou</strong>, amb data
              d'inici.
            </li>
            <li>
              Amb horari vigent: consultar/modificar períodes i franges (igual que a Horari d'empresa), canviar-lo o
              recuperar-ne un d'anterior.
            </li>
          </ul>
        </section>
      </>
    ),
  },
  absencies: {
    titol: "Com funcionen les Absències",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Per a què serveix</h4>
          <p>
            Vacances, permisos i altres absències dia a dia. Les baixes laborals no es creen aquí: van a la pestanya{" "}
            <strong>Baixes</strong>.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Calendari</h4>
          <ul>
            <li>
              <strong>Mes</strong> (per defecte): cel·les grans amb l'etiqueta de cada absència.
            </li>
            <li>
              <strong>Any complet</strong>: els 12 mesos de cop, més compacte (punts de color). La tipografia és la
              mateixa que al Calendari laboral de l'empresa.
            </li>
            <li>Clic a un dia buit (o arrossega dos dies) per crear. Clic a l'etiqueta/punt de color per editar o esborrar.</li>
          </ul>
        </section>
      </>
    ),
  },
  baixes: {
    titol: "Com funcionen les Baixes",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Per a què serveix</h4>
          <p>
            Baixes laborals amb data d'inici i, sovint, sense data final mentre continua oberta. No és un calendari: la
            taula és més clara. Al <strong>Calendari</strong> de l'empleat sí que es veuen superposades a l'any.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Què pots fer</h4>
          <p>Crear, finalitzar, modificar o esborrar. Els filtres (tipus, obertes/tancades, dates) s'apliquen sobre la llista ja carregada.</p>
        </section>
      </>
    ),
  },
  controlhorari: {
    titol: "Com funciona el Control Horari",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Per a què serveix</h4>
          <p>
            Fitxatges i còmput de la jornada d'aquest empleat. Aquí es consulta i, si cal, es corregeix des
            d'administració; no és el portal mòbil de fitxar.
          </p>
        </section>
      </>
    ),
  },
  calendari: {
    titol: "Com funciona el Calendari de l'empleat",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Per a què serveix</h4>
          <p>
            Vista de només lectura que combina horari, festius de l'empresa, absències i baixes. No substitueix les
            altres pestanyes: els botons <strong>Veure Horari / Absències / Baixes</strong> hi salten.
          </p>
        </section>
        <section className="dv2-help-section">
          <h4>Com es llegeix</h4>
          <ul>
            <li>
              <strong>Mes</strong> o <strong>Any complet</strong>, com a Absències. A l'any, les cel·les són compactes
              (mateixa lletra que el Calendari laboral).
            </li>
            <li>El color de fons/vora diu si el dia és festiu, no laborable, laborable o fora de vigència.</li>
            <li>Les absències i baixes es veuen com a etiquetes (mes) o punts (any), sense tapar el tipus de dia.</li>
          </ul>
        </section>
      </>
    ),
  },
  resum: {
    titol: "Com funciona el Resum",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Per a què serveix</h4>
          <p>
            Totals del període (objectiu, treballades, pendents o excedents) i una lectura ràpida de la situació laboral
            d'aquest empleat.
          </p>
        </section>
      </>
    ),
  },
};

export default AjudaGestioEmpleat;
